<script setup lang="ts">
import { definePage } from "unplugin-vue-router/runtime";
import ContractAddEditForm from "@/components/models/practice/forms/ContractAddEditForm.vue";
import { useContract } from "@/composables/models/practice/useContracts";
import { useRoute } from "vue-router";
import { computed } from "vue";
import { useAbility } from "@casl/vue";

definePage({
  meta: {
    title: "generic.action.editEntity",
    titleParams: { entity: "generic.entity.contract" },
    checkPrivileges: () => {
      const { can } = useAbility();
      return can($permActions.UPDATE, $permSubjects.PRACTICE__CONTRACT);
    },
  },
});

const route = useRoute();
const contractId = computed(() => (route.params as { id: string }).id);
const { data: defaultValues, isLoading } = useContract({ id: contractId.value });
</script>

<template>
  <loading v-if="isLoading" />
  <contract-add-edit-form
    v-else
    :defaultValues
  />
</template>
